<template>
  <div class="goods-container flex flex-col">
    <div class="goods__main">
      <!-- NOTE: flag === 3 时、商品分类不展示/无法获取中文枚举（只能通过接口来） -->
      <c-select-imitate v-if="flag === '1'" title="商品分类" :value="goods_category_text" @click="handleClickCategory"
        @clear="handleClearCategory" />

      <c-input title="商品编号" v-model="goods_no" :disabled="flag == 3" />

      <c-input title="商品名称" v-model="goods_name" :disabled="flag == 3" />

      <c-input title="商品品牌" v-model="goods_brand" :disabled="flag == 3" />

      <c-select-imitate title="商品规格" :value="goodsStandarsTxt" @click="handleClickStandards"
        @clear="handleClearStandards" />
    </div>

    <div class="goods__footer">
      <div class="btn-container">
        <div class="btn-span" @click="handleConfirmSubmit">{{ flag === '3' ? '修改' : '提交' }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.goods {
  &-container {
    height: 100vh;
    justify-content: space-between;

    .layout-container {
      margin-top: 10px;
    }

    .btn-container {
      margin-top: initial;
    }
  }

  &__main {
    height: 0;
    flex: 1;
  }
}
</style>

<script>

/**
 * @description 添加商品/修改商品页
 * @date 2023/11/30
 * @param flag = 3 表示修改
 * @param goods_id = xxx 商品Id
 */

import vueBus from '@/utils/vueBus';
import CInput from './components/CInput.vue';
// import CSelect from './components/CSelect.vue';
import CSelectImitate from './components/CSelectImitate.vue'
import { settingNavigationRight } from '@/utils/dingtalk'

export default {
  name: 'Goods',
  name_cn: '商品', // 新增或修改商品单项时存在
  components: {
    CInput,
    // CSelect,
    CSelectImitate
  },
  computed: {
    goodsStandarsTxt() {
      if (this.goods_stock.length) {
        return `共${this.goods_stock.length}个规格`
      } else {
        return ''
      }
    },
  },

  data: () => ({
    flag: '1', // 默认是新增:1 修改：3
    id: '', // 自定义商品的Id
    goods_id: undefined, // 商品id
    goods_category_first: '',
    goods_category_id: '',
    goods_category_text: '',
    goods_no: '',
    goods_name: '',
    goods_brand: '',
    goods_stock: [], // object[]
    row: null
  }),

  created() {
    this.navigationSetting()
    vueBus.$on('listenCategoryEvent', this.handleCategoryData)
    vueBus.$on('listenStrandarsEvent', this.handleStandarsData)
    const { flag } = this.$route.query
    if (flag === '3') { // update state
      const row = JSON.parse(this.$route.query.edit)
      if (row) {
        this.row = row
        console.log('%c update row??? >>>', 'background: blue; color: #fff', row);
        this.flag = flag
        this.goods_id = row.goods_id || undefined
        this.goods_category_first = row.goods_category_first || ''
        this.goods_category_id = row.goods_category_id || ''
        this.goods_no = row.goods_no || ''
        this.goods_name = row.goods_name || ''
        this.goods_brand = row.goods_brand || ''
        this.goods_stock = row.goods_stock || []
        if (row.__id__) this.id = row.__id__ // 自定义添加商品才有
      }
    }

  },
  methods: {
    // NOTE: 设置Right标题隐藏
    navigationSetting() {
      settingNavigationRight({
        show: false
      })
    },
    handleClickCategory() {
      this.$router.push({
        name: 'ProductStore',
        query: {
          type: '2'
        }
      })
    },
    handleClearCategory() {
      this.goods_category_first = ''
      this.goods_category_id = ''
      this.goods_category_text = ''
    },
    // NOTE: 处理商品分类数据
    handleCategoryData(data) {
      const { first, second } = data

      this.goods_category_text = `${first.name}/${second.name}`
      this.goods_category_first = first.id
      this.goods_category_id = second.id
    },
    handleClickStandards() {
      this.$router.push({
        name: 'GoodsSpeci',
        query: {
          // standars: this.standars.join(','),
          // NOTE: 只有type === 1才展示价格
          role: this.$route.query.flagtxt,
          type: this.$route.query.type,
          showPrice: Number(['1'].includes(this.$route.query.type)),
          goods_stock: JSON.stringify(this.goods_stock)
        }
      })
    },

    handleClearStandards() {
      this.goods_stock = []
    },

    // NOTE: 更新规格数据
    handleStandarsData(arrs) {
      this.goods_stock = [...arrs]

      if (this.row) { // 如果修改了规格；`flag` 字段变更成1； 后端重新录入规格
        this.row.flag = '1'
      }
    },

    // 确认提交
    handleConfirmSubmit() {
      const temporary = {
        flag: this.flag,
        goods_category_first: this.goods_category_first,
        goods_category_id: this.goods_category_id,
        goods_no: this.goods_no,
        goods_name: this.goods_name,
        goods_brand: this.goods_brand,
        goods_stock: this.goods_stock
      }

      if (this.flag === '3') { // update online goods
        if (this.row.flag) temporary.flag = this.row.flag

        if (this.goods_id) { // 线上商品
          temporary.goods_id = this.goods_id
        } else if (this.id) { // 新增商品-修改
          temporary['__id__'] = this.id
        }

      } else temporary['__id__'] = `${Date.now()}`

      vueBus.$emit('changeGoods', temporary)

      this.$nextTick(() => {
        this.$store.commit({
          type: "app/ROUTE_REMOVE",
          value: "Goods"
        })
        this.$router.go(-1)
      })
    }

  },
  beforeDestroy() {
    vueBus.$off('listenCategoryEvent')
    vueBus.$off('listenStrandarsEvent')
  }
}
</script>